export const DND_PRESS_DELAY_MS = 100;
